import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
interface MultiSelectFilterProps {
  label: string;
  options: {
    value: string;
    label: string;
    colorClass?: string;
  }[];
  selected: string[];
  onChange: (selected: string[]) => void;
}
export function MultiSelectFilter({
  label,
  options,
  selected,
  onChange
}: MultiSelectFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const toggleOption = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };
  const clearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange([]);
  };
  const hasSelection = selected.length > 0;
  return <div ref={ref} className="relative" data-id="element-182">
      <button onClick={() => setIsOpen(!isOpen)} className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors flex items-center gap-2 border ${hasSelection ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-slate-100 text-slate-700 border-transparent hover:bg-slate-200'}`} data-id="element-183">
        <span data-id="element-184">{label}</span>
        {hasSelection && <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 bg-blue-600 text-white rounded-full text-xs font-semibold" data-id="element-185">
            {selected.length}
          </span>}
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-186" />
      </button>

      <AnimatePresence data-id="element-187">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.15
      }} className="absolute left-0 top-full mt-1 min-w-[240px] bg-white rounded-lg border border-slate-200 shadow-lg z-20 py-1 max-h-80 overflow-y-auto" data-id="element-188">
            <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100" data-id="element-189">
              <span className="text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-190">
                {label}
              </span>
              {hasSelection && <button onClick={clearAll} className="text-xs text-blue-600 hover:text-blue-700 font-medium" data-id="element-191">
                  Clear
                </button>}
            </div>
            {options.map(option => {
          const isSelected = selected.includes(option.value);
          return <button key={option.value} onClick={() => toggleOption(option.value)} className="w-full px-3 py-2 text-sm text-left flex items-center justify-between gap-2 hover:bg-slate-50 transition-colors" data-id="element-192">
                  <div className="flex items-center gap-2" data-id="element-193">
                    <div className={`w-4 h-4 rounded border flex items-center justify-center transition-colors ${isSelected ? 'bg-blue-600 border-blue-600' : 'border-slate-300 bg-white'}`} data-id="element-194">
                      {isSelected && <Check className="w-3 h-3 text-white" data-id="element-195" />}
                    </div>
                    {option.colorClass ? <span className={`px-2 py-0.5 rounded text-xs font-semibold ${option.colorClass}`} data-id="element-196">
                        {option.label}
                      </span> : <span className="text-slate-700" data-id="element-197">{option.label}</span>}
                  </div>
                </button>;
        })}
          </motion.div>}
      </AnimatePresence>
    </div>;
}